import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import { useListPlaidAccounts } from 'hooks/useListPlaidAccounts';
import { useDisbursementSettings } from 'hooks/useDisbursementSettings';
import { useUpdateDisbursementSettings } from 'hooks/useUpdateDisbursementSettings';

const DisbursementSettingsSection: React.FC = () => {
  const { data: plaidAccounts, isLoading } = useListPlaidAccounts();
  const { data: disbursementSettings, isLoading: isSettingsLoading } = useDisbursementSettings();
  const { mutate: updateDisbursementSettings, isPending: isUpdatingSettings } = useUpdateDisbursementSettings();

  const [selectedSourceAccountId, setSelectedSourceAccountId] = useState<number | ''>('');

  useEffect(() => {
    if (disbursementSettings?.sourceAccount?.id) {
      setSelectedSourceAccountId(Number(disbursementSettings.sourceAccount.id));
    }
  }, [disbursementSettings]);

  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Disbursement Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select the default source account for disbursements.
      </Typography>
      {isSettingsLoading || isLoading ? (
        <Typography>Loading...</Typography>
      ) : (
        <Box sx={{ maxWidth: 400 }}>
          <form
            onSubmit={e => {
              e.preventDefault();
              if (selectedSourceAccountId) {
                updateDisbursementSettings({ source_account_id: Number(selectedSourceAccountId) });
              }
            }}
          >
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="source-account-label">Source Account</InputLabel>
              <Select
                labelId="source-account-label"
                id="source_account_id"
                name="source_account_id"
                label="Source Account"
                value={selectedSourceAccountId}
                onChange={e => setSelectedSourceAccountId(Number(e.target.value))}
                disabled={isUpdatingSettings}
              >
                <MenuItem value="" disabled>Select an account...</MenuItem>
                {plaidAccounts?.map(acc => (
                  <MenuItem key={acc.id} value={acc.id}>
                    {acc.name} {acc.official_name ? `(${acc.official_name})` : ''} {acc.mask ? `****${acc.mask}` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              disabled={isUpdatingSettings}
              sx={{ borderRadius: 2, fontWeight: 600 }}
            >
              {isUpdatingSettings ? 'Saving...' : 'Save'}
            </Button>
          </form>
        </Box>
      )}
    </>
  );
};

export default DisbursementSettingsSection; 